export { embedFFDataToUFO } from './ufo-feature-flags';
